import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  align-items: stretch;
  min-width: 0;
  width: 100%;
  max-width: 320px;
  min-height: 80px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.widget_background};
  box-sizing: border-box;
  overflow: hidden;

  @media (min-width: 400px) {
    max-height: 104px;
    width: auto;
    width: 213px;
  }
`;

const Main = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 10px 12px 14px;

  @media (min-width: 400px) {
    padding: 12px 12px 12px 12px;
    gap: 6px;
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

const PlayButton = styled.button`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 4px;
  border: none;
  background: ${(props) => props.theme.colors.outline};
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: ${(props) => props.theme.colors.widget_hover_background};
  }
  &:focus {
    outline: none;
  }
`;

const Content = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 0;
`;

const FileName = styled.span`
  font-size: 13px;
  line-height: 1.35;
  color: ${(props) => props.theme.colors.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Meta = styled.span`
  font-size: 12px;
  line-height: 1.35;
  color: ${(props) => props.theme.colors.inactive};
`;

const Actions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
`;

const IconButton = styled.button<{ danger?: boolean }>`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${(props) => (props.danger ? props.theme.colors.red : props.theme.colors.inactive)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${(props) => (props.danger ? props.theme.colors.red : props.theme.colors.text)};
  }
  &:focus {
    outline: none;
  }
`;

const SendBar = styled.div`
  width: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.outline};
  border-left: 1px solid ${(props) => props.theme.colors.outline};
`;

const SendButton = styled.button`
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${(props) => props.theme.colors.main_cta};
  }
  &:focus {
    outline: none;
  }
`;

const styles = {
  Card,
  Main,
  TopRow,
  PlayButton,
  Content,
  FileName,
  Meta,
  Actions,
  IconButton,
  SendBar,
  SendButton,
};

export default styles;
